/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.50.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BadRequestResponse,
  CreatePhoto,
  ForbiddenErrorResponse,
  GetPhotoByIdParams,
  GetPhotoResponse,
  Id,
  LegacyLinkPhotosToAsset,
  LegacyLinkPhotosToAssetParams,
  LegacyUnlinkPhotosFromAsset,
  LegacyUnlinkPhotosFromAssetParams,
  LinkPhotosToAsset,
  LinkPhotosToAssetParams,
  RemovePhoto,
  UnauthorizedErrorResponse,
  UnlinkPhotosFromAsset,
  UnlinkPhotosFromAssetParams,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

export const createPhoto = (
  tenantId: Id,
  photoId: Id,
  createPhoto: CreatePhoto,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/photo/aggregate/photo/${photoId}/create-photo`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPhoto,
    signal,
  });
};

export const getCreatePhotoMutationOptions = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhoto>>,
    TError,
    { tenantId: Id; photoId: Id; data: CreatePhoto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPhoto>>,
  TError,
  { tenantId: Id; photoId: Id; data: CreatePhoto },
  TContext
> => {
  const mutationKey = ["createPhoto"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPhoto>>,
    { tenantId: Id; photoId: Id; data: CreatePhoto }
  > = (props) => {
    const { tenantId, photoId, data } = props ?? {};

    return createPhoto(tenantId, photoId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPhoto>>
>;
export type CreatePhotoMutationBody = CreatePhoto;
export type CreatePhotoMutationError =
  | void
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useCreatePhoto = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPhoto>>,
      TError,
      { tenantId: Id; photoId: Id; data: CreatePhoto },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPhoto>>,
  TError,
  { tenantId: Id; photoId: Id; data: CreatePhoto },
  TContext
> => {
  const mutationOptions = getCreatePhotoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const removePhoto = (
  tenantId: Id,
  photoId: Id,
  removePhoto: RemovePhoto,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/photo/aggregate/photo/${photoId}/remove-photo`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: removePhoto,
    signal,
  });
};

export const getRemovePhotoMutationOptions = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removePhoto>>,
    TError,
    { tenantId: Id; photoId: Id; data: RemovePhoto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removePhoto>>,
  TError,
  { tenantId: Id; photoId: Id; data: RemovePhoto },
  TContext
> => {
  const mutationKey = ["removePhoto"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removePhoto>>,
    { tenantId: Id; photoId: Id; data: RemovePhoto }
  > = (props) => {
    const { tenantId, photoId, data } = props ?? {};

    return removePhoto(tenantId, photoId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemovePhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof removePhoto>>
>;
export type RemovePhotoMutationBody = RemovePhoto;
export type RemovePhotoMutationError =
  | void
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useRemovePhoto = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removePhoto>>,
      TError,
      { tenantId: Id; photoId: Id; data: RemovePhoto },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof removePhoto>>,
  TError,
  { tenantId: Id; photoId: Id; data: RemovePhoto },
  TContext
> => {
  const mutationOptions = getRemovePhotoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetch a photo by its ID
 * @summary Get photo by ID
 */
export const getPhotoById = (
  params: GetPhotoByIdParams,
  signal?: AbortSignal
) => {
  return httpClient<GetPhotoResponse>({
    url: `/query-service/photo-information/get-photo-by-id`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPhotoByIdQueryKey = (params?: GetPhotoByIdParams) => {
  return [
    "query-service",
    "photo-information",
    "get-photo-by-id",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPhotoByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhotoById>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  params: GetPhotoByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhotoById>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhotoByIdQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhotoById>>> = ({
    signal,
  }) => getPhotoById(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhotoById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPhotoByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhotoById>>
>;
export type GetPhotoByIdQueryError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

export function useGetPhotoById<
  TData = Awaited<ReturnType<typeof getPhotoById>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  params: GetPhotoByIdParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhotoById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoById>>,
          TError,
          Awaited<ReturnType<typeof getPhotoById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhotoById<
  TData = Awaited<ReturnType<typeof getPhotoById>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  params: GetPhotoByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhotoById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoById>>,
          TError,
          Awaited<ReturnType<typeof getPhotoById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhotoById<
  TData = Awaited<ReturnType<typeof getPhotoById>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  params: GetPhotoByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhotoById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get photo by ID
 */

export function useGetPhotoById<
  TData = Awaited<ReturnType<typeof getPhotoById>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  params: GetPhotoByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhotoById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhotoByIdQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const linkPhotosToAsset = (
  tenantId: Id,
  assetId: Id,
  linkPhotosToAsset: LinkPhotosToAsset,
  params: LinkPhotosToAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/link-photos-to-asset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: linkPhotosToAsset,
    params,
    signal,
  });
};

export const getLinkPhotosToAssetMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkPhotosToAsset>>,
    TError,
    {
      tenantId: Id;
      assetId: Id;
      data: LinkPhotosToAsset;
      params: LinkPhotosToAssetParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkPhotosToAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: LinkPhotosToAsset;
    params: LinkPhotosToAssetParams;
  },
  TContext
> => {
  const mutationKey = ["linkPhotosToAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkPhotosToAsset>>,
    {
      tenantId: Id;
      assetId: Id;
      data: LinkPhotosToAsset;
      params: LinkPhotosToAssetParams;
    }
  > = (props) => {
    const { tenantId, assetId, data, params } = props ?? {};

    return linkPhotosToAsset(tenantId, assetId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkPhotosToAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof linkPhotosToAsset>>
>;
export type LinkPhotosToAssetMutationBody = LinkPhotosToAsset;
export type LinkPhotosToAssetMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useLinkPhotosToAsset = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkPhotosToAsset>>,
      TError,
      {
        tenantId: Id;
        assetId: Id;
        data: LinkPhotosToAsset;
        params: LinkPhotosToAssetParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof linkPhotosToAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: LinkPhotosToAsset;
    params: LinkPhotosToAssetParams;
  },
  TContext
> => {
  const mutationOptions = getLinkPhotosToAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const unlinkPhotosFromAsset = (
  tenantId: Id,
  assetId: Id,
  unlinkPhotosFromAsset: UnlinkPhotosFromAsset,
  params: UnlinkPhotosFromAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/unlink-photos-from-asset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: unlinkPhotosFromAsset,
    params,
    signal,
  });
};

export const getUnlinkPhotosFromAssetMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkPhotosFromAsset>>,
    TError,
    {
      tenantId: Id;
      assetId: Id;
      data: UnlinkPhotosFromAsset;
      params: UnlinkPhotosFromAssetParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlinkPhotosFromAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: UnlinkPhotosFromAsset;
    params: UnlinkPhotosFromAssetParams;
  },
  TContext
> => {
  const mutationKey = ["unlinkPhotosFromAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlinkPhotosFromAsset>>,
    {
      tenantId: Id;
      assetId: Id;
      data: UnlinkPhotosFromAsset;
      params: UnlinkPhotosFromAssetParams;
    }
  > = (props) => {
    const { tenantId, assetId, data, params } = props ?? {};

    return unlinkPhotosFromAsset(tenantId, assetId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlinkPhotosFromAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlinkPhotosFromAsset>>
>;
export type UnlinkPhotosFromAssetMutationBody = UnlinkPhotosFromAsset;
export type UnlinkPhotosFromAssetMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useUnlinkPhotosFromAsset = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unlinkPhotosFromAsset>>,
      TError,
      {
        tenantId: Id;
        assetId: Id;
        data: UnlinkPhotosFromAsset;
        params: UnlinkPhotosFromAssetParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof unlinkPhotosFromAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: UnlinkPhotosFromAsset;
    params: UnlinkPhotosFromAssetParams;
  },
  TContext
> => {
  const mutationOptions = getUnlinkPhotosFromAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const legacyLinkPhotosToAsset = (
  tenantId: Id,
  assetId: Id,
  legacyLinkPhotosToAsset: LegacyLinkPhotosToAsset,
  params: LegacyLinkPhotosToAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/legacy-link-photos-to-asset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: legacyLinkPhotosToAsset,
    params,
    signal,
  });
};

export const getLegacyLinkPhotosToAssetMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legacyLinkPhotosToAsset>>,
    TError,
    {
      tenantId: Id;
      assetId: Id;
      data: LegacyLinkPhotosToAsset;
      params: LegacyLinkPhotosToAssetParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof legacyLinkPhotosToAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: LegacyLinkPhotosToAsset;
    params: LegacyLinkPhotosToAssetParams;
  },
  TContext
> => {
  const mutationKey = ["legacyLinkPhotosToAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof legacyLinkPhotosToAsset>>,
    {
      tenantId: Id;
      assetId: Id;
      data: LegacyLinkPhotosToAsset;
      params: LegacyLinkPhotosToAssetParams;
    }
  > = (props) => {
    const { tenantId, assetId, data, params } = props ?? {};

    return legacyLinkPhotosToAsset(tenantId, assetId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type LegacyLinkPhotosToAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof legacyLinkPhotosToAsset>>
>;
export type LegacyLinkPhotosToAssetMutationBody = LegacyLinkPhotosToAsset;
export type LegacyLinkPhotosToAssetMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useLegacyLinkPhotosToAsset = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof legacyLinkPhotosToAsset>>,
      TError,
      {
        tenantId: Id;
        assetId: Id;
        data: LegacyLinkPhotosToAsset;
        params: LegacyLinkPhotosToAssetParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof legacyLinkPhotosToAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: LegacyLinkPhotosToAsset;
    params: LegacyLinkPhotosToAssetParams;
  },
  TContext
> => {
  const mutationOptions = getLegacyLinkPhotosToAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const legacyUnlinkPhotosFromAsset = (
  tenantId: Id,
  assetId: Id,
  legacyUnlinkPhotosFromAsset: LegacyUnlinkPhotosFromAsset,
  params: LegacyUnlinkPhotosFromAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/legacy-unlink-photos-from-asset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: legacyUnlinkPhotosFromAsset,
    params,
    signal,
  });
};

export const getLegacyUnlinkPhotosFromAssetMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legacyUnlinkPhotosFromAsset>>,
    TError,
    {
      tenantId: Id;
      assetId: Id;
      data: LegacyUnlinkPhotosFromAsset;
      params: LegacyUnlinkPhotosFromAssetParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof legacyUnlinkPhotosFromAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: LegacyUnlinkPhotosFromAsset;
    params: LegacyUnlinkPhotosFromAssetParams;
  },
  TContext
> => {
  const mutationKey = ["legacyUnlinkPhotosFromAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof legacyUnlinkPhotosFromAsset>>,
    {
      tenantId: Id;
      assetId: Id;
      data: LegacyUnlinkPhotosFromAsset;
      params: LegacyUnlinkPhotosFromAssetParams;
    }
  > = (props) => {
    const { tenantId, assetId, data, params } = props ?? {};

    return legacyUnlinkPhotosFromAsset(tenantId, assetId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type LegacyUnlinkPhotosFromAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof legacyUnlinkPhotosFromAsset>>
>;
export type LegacyUnlinkPhotosFromAssetMutationBody =
  LegacyUnlinkPhotosFromAsset;
export type LegacyUnlinkPhotosFromAssetMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useLegacyUnlinkPhotosFromAsset = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof legacyUnlinkPhotosFromAsset>>,
      TError,
      {
        tenantId: Id;
        assetId: Id;
        data: LegacyUnlinkPhotosFromAsset;
        params: LegacyUnlinkPhotosFromAssetParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof legacyUnlinkPhotosFromAsset>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: LegacyUnlinkPhotosFromAsset;
    params: LegacyUnlinkPhotosFromAssetParams;
  },
  TContext
> => {
  const mutationOptions =
    getLegacyUnlinkPhotosFromAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
